import script from "./DateRangePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateRangePicker.vue?vue&type=script&lang=ts&setup=true"

import "./DateRangePicker.vue?vue&type=style&index=0&id=b95ede54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b95ede54"]])

export default __exports__